import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import { Spin, message } from 'antd';
import api from '../../api';
import { userErrorHandler } from '../../api/user';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function AutoLoginPage() {
    const history = useHistory();
    const query = useQuery();

    useEffect(() => {
        const token = query.get('token');

        if (!token) {
            message.error('ไม่พบ token สำหรับเข้าสู่ระบบ');
            history.push('/');
            return;
        }

        handleAutoLogin(token);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleAutoLogin = async (token) => {
        try {
            const response = await api.user.verifyLaunchToken(token);

            if (response.data && response.data.success) {
                // เก็บ token และ username ลงใน localStorage
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('username', response.data.username);

                message.success('เข้าสู่ระบบสำเร็จ!');

                // redirect ไปหน้าหลักของเกม
                setTimeout(() => {
                    history.push('/handicap');
                    window.location.reload();
                }, 1000);
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (err) {
            console.error('Auto login error:', err);
            userErrorHandler(err);

            if (err.response?.status === 401) {
                message.error('Link หมดอายุหรือไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง');
            } else {
                message.error('เกิดข้อผิดพลาดในการเข้าสู่ระบบ');
            }

            // redirect กลับไปหน้า login หลังจาก 3 วินาที
            setTimeout(() => {
                history.push('/');
            }, 3000);
        }
    };

    return (
        <div style={{
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            backgroundColor: '#f0f2f5'
        }}>
            <Spin size="large" />
            <div style={{
                marginTop: 20,
                fontSize: 18,
                color: '#333',
                fontFamily: 'Kanit'
            }}>
                กำลังเข้าสู่ระบบ...
            </div>
            <div style={{
                marginTop: 10,
                fontSize: 14,
                color: '#666',
                fontFamily: 'Kanit'
            }}>
                โปรดรอสักครู่
            </div>
        </div>
    );
}

export default AutoLoginPage;